import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import { NewPasswordType } from '@/shared/types'

class SettingsApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public updateProfile(profileData: NewPasswordType) {
    const { email, password, passwordConfirmation } = profileData

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/users/profile/update',
      data: {
        email,
        password,
        password_confirmation: passwordConfirmation,
      },
    })
  }
}

export const settingsApi = new SettingsApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
